export default "__VITE_ASSET__BWIBukSV__"